export const isIriInProjectModels = (
  iri: string,
  projectModelIds: Set<string>,
  modelsByIri: Record<string, string[]>,
  targetModelId: string
) => {
  return (modelsByIri[iri] || [targetModelId]).some((model) =>
    projectModelIds.has(model)
  );
};
